import { createStore } from "zustand/vanilla";
import { useStore } from "zustand";

/** snapshot: painted from KV, socket not open yet · live: socket open · reconnecting: dropped, retrying */
export type ConnStatus = "snapshot" | "connecting" | "live" | "reconnecting";

export interface ConnectionState {
  status: ConnStatus;
  snapshotAt: string | null; // ISO time of the snapshot we painted from
  attempts: number;
}

export const connectionStore = createStore<ConnectionState>()(() => ({
  status: "snapshot",
  snapshotAt: null,
  attempts: 0,
}));

export const useConnection = <T,>(selector: (s: ConnectionState) => T) => useStore(connectionStore, selector);
